const locale = {
  FORM_VALIDATION_PLACEHOLDER_INPUT: '#',
  FORM_VALIDATION_FIELD_REQUIRED: 'Ingresa tu código para continuar',
  FORM_VALIDATION_MAXIMUM_CHARACTERS: 'Ingresa un código de 6 dígitos',
  FORM_VALIDATION_FIRST_ATTEMPT: 'Código incorrecto. Te quedan 2 intentos',
  FORM_VALIDATION_SECOND_ATTEMPT: 'Código incorrecto. Te queda 1 intento',
  FORM_VALIDATION_THIRD_ATTEMPT: 'Código incorrecto. Podrás intentarlo de nuevo en una hora',
};

export default locale;
